import React, { useState, useEffect, useContext } from 'react'
import { useIntl, FormattedMessage } from 'react-intl'

import { FACILITIES } from 'client/components/FilterFacilities/constants'
import { FiltersContext } from 'client/components/FiltersContainer/context'
import IconFacility from 'client/icons/facilities/Facility'

import { FilterFacilitiesBase, Title, FacilityText, List, Item, Label, Checkbox } from './styles'
import globalMessages from 'client/messages'
import messages from './messages'

const FilterFacilities = () => {
  const intl = useIntl()
  const { filters, setFilters } = useContext(FiltersContext)
  const [selected, setSelected] = useState([])

  useEffect(() => {
    setSelected(filters.facilities || [])
  }, [filters.facilities])

  function translate(copy, values) {
    return messages[copy] && { [copy]: intl.formatMessage(messages[copy], values) }
  }

  const facilitiesMessages = {
    ...translate('airportshuttle'),
    ...translate('carpark'),
    ...translate('facilities'),
    ...translate('gym'),
    ...translate('indoorpool'),
    ...translate('outdoorpool'),
    ...translate('restaurant'),
    ...translate('safebox'),
    ...translate('spa'),
    ...translate('wheelchair'),
    ...translate('wifi'),
  }

  function handleClick(event) {
    const facility = event.target.name
    const index = selected.indexOf(facility)
    const facilityExists = index > -1
    const filteredFacilities = facilityExists
      ? selected.filter((f, i) => i !== index)
      : [...selected, facility]

    setFilters({ ...filters, facilities: filteredFacilities })
  }

  return (
    <FilterFacilitiesBase>
      <Title>
        <FormattedMessage {...globalMessages.facilities} />
      </Title>

      <List>
        {FACILITIES.map(facility => {
          const { id, name, icon, slug } = facility
          const formattedName = name.toLowerCase()
          const isSelected = !!selected.find(f => f === slug)

          return (
            <Item key={id}>
              <Label htmlFor={`facility-${slug}`} selected={isSelected}>
                <IconFacility name={icon} />
                <Checkbox
                  id={`facility-${slug}`}
                  name={slug}
                  onChange={handleClick}
                  type="checkbox"
                />
                <FacilityText>{facilitiesMessages[formattedName]}</FacilityText>
              </Label>
            </Item>
          )
        })}
      </List>
    </FilterFacilitiesBase>
  )
}

export default FilterFacilities
